<template>
  <div>
    <section class="artContainer votreSejour">
      <div>
        <h2 class="titlePage">
          <strong>_</strong>
          Votre séjour
          <strong>_</strong>
        </h2>
        <p>
          Notre grande capacité de couchage permet également de belles fêtes de famille, des anniversaires, des cousinades, des mariages….
          <br />Toutes les occasions seront bonnes pour des retrouvailles !
        </p>
        <p>
          Quelle que soit la formule que vous recherchez et selon vos envies, en préparation de votre voyage ou pendant votre séjour, vous pourrez bénéficier de
          <br />notre conseil pour profiter des activités proposées sur notre territoire. Nous vous mettrons en contact avec les professionnels locaux et compétents.
          <br />Nous les connaissons bien, vous pouvez leur faire confiance
        </p>
      </div>

      <div class="bottomupDiapo">
        <Slideshow
          sliderheight="60vh"
          :slidewidth="getSlidesWidth()"
          bubbles="mybubbles"
          activeclass="activeSl"
          unactiveclass="unactiveSl"
          :slidespeed="getSlidesSpeed()"
          rightnav_class="fas fa-angle-double-right fa-2x"
          leftnav_class="fas fa-angle-double-left fa-2x"
        >
          <div>
            <img src="@/assets/images/votresejour/P1070844.jpg" alt />
          </div>

          <div>
            <img src="@/assets/images/votresejour/Dortoir.jpg" alt />
          </div>
          <div>
            <img src="@/assets/images/votresejour/SEJOURS-salleamanger.jpg" alt />
          </div>
          <div>
            <img src="@/assets/images/votresejour/table.jpg" alt />
          </div>
          <div>
            <img src="@/assets/images/votresejour/cuisine.jpg" alt />
          </div>
          <div>
            <img src="@/assets/images/votresejour/P1070890.jpg" alt />
          </div>
        </Slideshow>
      </div>

      <div class="lastdiv">
        <p>
          Au village de Touget, nous bénéficions d’une magnifique <a href="https://www.mairie-touget.fr/spip.php?rubrique50" target="_blancs"><u>salle de réception</u></a> de caractère, idéale pour l’organisation de mariage.
          <br />Seulement 2 kilomètres séparent ce bel édifice et le Gîte d’En Lébé. Nous pourrons accueillir vos familles et vos amis.
        </p>
      </div>

      <div class>
        <router-link to="/contact" class="greenBtn">Contactez-nous</router-link>
      </div>
    </section>
    <GreenBarContact></GreenBarContact>
  </div>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import GreenBarContact from "@/components/GreenBarContact.vue";

export default {
  name: "VotreSejour",
  data: function () {
    return {};
  },
  components: {
    Slideshow,
    GreenBarContact,
  },
  created() {},
  mounted() {},
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getSlidesWidth() {
      if (window.innerWidth > 1100) {
        return "60";
      } else if (window.innerWidth > 600) {
        return "80";
      } else return "100";
    },
    getSlidesSpeed() {
      if (window.innerWidth > 1100) {
        return "1000";
      } else if (window.innerWidth > 600) {
        return "700";
      } else return "400";
    },
  },
};
</script>
<style >
.votreSejour {
  text-align: center;
}
.votreSejour section {
  display: flex;
  margin-top: 2rem;
}

.votreSejour p {
  letter-spacing: 0.5px;
  margin: 3rem 0;
  font-size: 1.2rem;
}

.votreSejour .bottomupDiapo {
  margin: 3rem 0 2rem;
}
.unactiveSl {
  transition-duration: 0.8s;
  transform: scale(0.8);
}
.activeSl {
  transition-duration: 0.8s;
}
.mybubbles {
  width: 14px;
  height: 14px;
  margin: 0 2px;
  cursor: pointer;
}
.bottomupDiapo .activeBubble {
  background: var(--dark-color);
  border-color: var(--dark-color);
}
.bottomupDiapo .unactiveBubble {
  border-color: var(--dark-color);
}
.bottomupDiapo .bubbleBox {
  bottom: -25px;
}
.votreSejour .slideBtn {
  background: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
.votreSejour .greenBtn {
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
}
.lastdiv {
  width: 100%;
  margin: 2rem 0 0rem;
}

.lastdiv a {
  color: var(--dark-color);
  font-weight: bold;
}
@media all and (max-width: 1100px) {
  /* .activeSl {
    transform: scale(0.9);
  } */
  .bubbleBox {
    bottom: 0;
  }
}
@media all and (max-width: 600px) {
  .bottomupDiapo .slideBtn {
    display: none;
  }
}
</style>